import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Select } from 'antd';

import PopoverError from '../commons/popoverError';

const Option = Select.Option;

const renderOpcions = (opcions) => {
    return opcions.map(opcio => {
        return (
            <Option
                key={opcio.id.toString()}
                value={opcio.id.toString()} >
                {opcio.nom}
            </Option>
        );
    });
};

class AvisIntroduccioSeccioDadesMeteorCampLlista extends Component {

    componentWillMount() {
        const { valor, valorsPossibles, id } = this.props.camp;

        let valorPerDefecte;
        const valorPossibleMarcatPerDefecte = valorsPossibles.find(valor => valor.valorPerDefecte === true);

        if (valor) {
            valorPerDefecte = valor;
        } else if (valorPossibleMarcatPerDefecte) {
            valorPerDefecte = valorPossibleMarcatPerDefecte.id;
            this.props.onModificarValor(id, valorPerDefecte);
        }
    }

    render() {
        const { camp, onModificarValor } = this.props;
        const { nom, error, id, valor } = camp;

        const valorPerDefecte = (valor === undefined) ? null : valor.toString();
        const errorRenderitzat = (error) ? <PopoverError contingut='Camp obligatori' /> : null;

        return (
            <div className='avis-introduccio-seccio-dades-meteor-camp'>
                <span className='titol'>
                    {nom}:
                </span>
                <Select
                    placeholder='Selecciona una opció'
                    allowClear
                    value={valorPerDefecte}
                    onChange={(valorSeleccionat) => onModificarValor(id, valorSeleccionat)}>
                    {renderOpcions(camp.valorsPossibles)}
                </Select>
                {errorRenderitzat}
            </div>
        );
    }
}

AvisIntroduccioSeccioDadesMeteorCampLlista.propTypes = {
    camp: PropTypes.object.isRequired,
    onModificarValor: PropTypes.func.isRequired
};

export default AvisIntroduccioSeccioDadesMeteorCampLlista;



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesMeteorCampLlista.js